import React from 'react';
import { Waypoint } from 'react-waypoint';
import { ElementLoader } from 'ui';
import { deepEquals } from 'app/infrastructure/js';
import { SearchFilters } from 'app/area/search-filters/search-filters';
import { SerializePayload } from 'app/area/search-filters/types';
import { CompanyReportsSearchModel, ListRendererProps } from '../types-store';
import { serialize } from '../serialize';
import { ListResults } from './list-results';
import { Link } from 'react-router-dom';
import { routeConstants } from 'app/routes/route-constants';
import styles from './list-renderer.scss';

export const ListRenderer: React.FC<ListRendererProps> = ({
  listState, loadList, deleteCompanyReport, translation
}) => {

  const { fetching, requestedSearchModel, listItems, numberOfResults, deletingCompanyReports } = listState;

  const updateSearchModel = (payload: SerializePayload) => {
    onLoadData(serialize(payload));
  };

  const onLoadData = (searchModel: CompanyReportsSearchModel, startIndex?: number) => {

    if (startIndex !== undefined || !deepEquals(searchModel, requestedSearchModel)) {
      loadList(searchModel, startIndex);
    }
  };

  const onFetchMore = () => {

    if (fetching || !listItems || listItems.length === 0 || listItems.length === numberOfResults) {
      return;
    }

    onLoadData(requestedSearchModel, listItems.length);
  };

  const topToolbar = <div className="row">
    <h1 className="col-12">{translation.manage_company_reports_title}</h1>
  </div>;

  const rightToolbar = <Link
    id="company-reports-admin-add-new-button"
    to={routeConstants.companyReportAdminAdd}
    className="btn btn-primary">
    {translation.add_new}
  </Link>;

  return <>
    <SearchFilters
      topToolbar={topToolbar}
      rightToolbar={rightToolbar}
      filtersConfig={{ area: 'companyReportAdmin' }}
      hideDrawer={true}
      queryFilters={undefined}
      predefinedFilters={undefined}
      customFilters={undefined}
      defaultFilterValues={undefined}
      updateSearchModel={updateSearchModel}>
      {!!listItems && <div className="row">
        <div className="col-12">
          <div id="company_reports_number_of_results"
            className={styles.noOfResults}>
            {numberOfResults === 0
              ? translation.search_no_company_reports
              : `${numberOfResults} ${translation.search_hits}`}
          </div>
        </div>
      </div>}
      {listItems && listItems.length > 0
        ? <ListResults
          listItems={listItems}
          deletingCompanyReports={deletingCompanyReports}
          deleteCompanyReport={deleteCompanyReport}
          translation={translation} />
        : null}
      <Waypoint key="wpCompanyReportsAdmin" onEnter={onFetchMore} scrollableAncestor={window} bottomOffset="-10%" />
      {listState.fetching ? <ElementLoader /> : null}
    </SearchFilters>
  </>;
};
